<template>
  <div class="riskList">
    <div class="table-box">
      <div class="title">
        <div class="flex justify-start align-center" >
          <div class="icon-box">
            <i class="iconfont icon-daiban"></i>
          </div>
          <b>申诉记录</b>
        </div>
        <div class="page-cancel" @click="$router.go(-1)">
          <i class="icon iconfont icon-jiantouzuo1"></i>返回
        </div>
      </div>
      <div class="search-flex">
        <div class="search-box">
          <el-form ref="form" :model="search" label-width="80px" class="flex">
            <el-form-item label="关键词">
              <el-input v-model="search.keyword" clearable placeholder="请输入关键词搜索"></el-input>
            </el-form-item>
          </el-form>
          <div class="search-btn" @click="searchFun">
            <i class="iconfont icon-sousuo"></i>搜索
          </div>
        </div>
      </div>
      <div class="list ">
        <el-table
          border
          :data="tableData"
          :header-cell-style="centerbgc"
          :cell-style="textCenter"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            width="130"
            label="状态">
            <template slot-scope="scope">
              <div class="btn gray" v-if="scope.row.status == -1">已撤销</div>
              <div class="btn shen" v-if="scope.row.status == 0">待审核</div>
              <div class="btn orange" v-if="scope.row.status == 1">受理中</div>
              <div class="btn green" v-if="scope.row.status == 3">已完成</div>
              <div class="btn red" v-if="scope.row.status == 2">已拒绝</div>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            prop="name"
            label="姓名">
          </el-table-column>
          <el-table-column
            width="150"
            prop="phone"
            label="联系方式">
          </el-table-column>
          <el-table-column
            prop="content"
            label="申诉内容">
          </el-table-column>
          <el-table-column
            width="120"
            label="材料附件">
            <template slot-scope="scope">
              <div class="btn blue" @click="download(scope.row)">下载</div>
            </template>
          </el-table-column>
          <el-table-column
            width="250"
            prop="update_time"
            label="反馈时间">
          </el-table-column>
          <el-table-column
            label="操作"
            width="300">
            <template slot-scope="scope" class="flex">
              <div class="edit" v-if="scope.row.status > 1" @click="look(scope.row)">查看受理结果</div>
              <div class="edit" v-if="scope.row.status > 1" @click="reset(scope.row,'向主管部门投诉',null,2)">向主管部门投诉</div>
              <div class="edit" v-if="scope.row.status == 0" @click="reset(scope.row,'撤销',-1,null)">撤销</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {isYes,riskLevelOptions} from "@/utils/const";
import {star_shensu_lst,star_shensu_set} from "@/api";
import {frontDownload} from "@/utils/utils";

export default {
  name: "evaluateAppealList",
  data() {
    return {
      isYes:isYes,
      riskLevelOptions:riskLevelOptions,
      dialogVisible: false,
      lookid:'',
      search:{
        keyword: '',
        page:1,
        limit:10,
        total:0,
      },
      tableData:[]
    }
  },
  components: {},
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 3
    })
    this.list()
  },
  methods: {
    async list(){
      let _data = await star_shensu_lst(
        this.search.keyword,
        this.search.page,
        this.search.limit
      );
      if(_data.status == 200) {
        this.tableData = _data.data.data;
        this.search.total = _data.data.total;
      }
    },
    download(row){
      frontDownload(row.files)
    },

    searchFun() {
      this.search.page = 1
      this.tableData = []
      this.list()
    },

    reset(row,title,status,isUp) {
      this.$confirm(`确定${title}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let _data = await star_shensu_set(
          row.id,
          status,
          isUp
        ).then(res => {
          if(res.status == 200) {
            this.$message({
              message:_data.msg,
              type: 'success'
            });
            this.list()
          }
        })
      })
    },
    look(row){
      if(row.status == 2) {
        // status = 2  被拒的情况下查看拒绝理由   remark
        this.$alert(`${row.remark}`, '受理结果', {
          confirmButtonText: '确定'
        });
      }
      if(row.status == 3) {
        // status=3  查看受理结果附件 jieguo_file
        let _row = {
          files: row.jieguo_file
        }
        this.download(_row)
      }
    },
    handleClose(){
      this.dialogVisible = false
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.riskList {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  .edit {
    display: inline-block;
    margin: 0 15px;
    color: #0089ff;
    cursor: pointer;
  }
  .table-box {
    width: 100%;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    padding: 0 20px;
    border-radius: 10px;
    min-height: 500px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      border-bottom: 2px solid #e3e7f0;
      b {
        font-size: 22px;
        color: #16181d;
        font-weight: bold;
        margin-left: 10px;
      }
      .icon-box {
        width: 30px;
        height: 30px;
        background-image: linear-gradient(-30deg,
          #3579fb 0%,
          #44a3ff 100%);
        box-shadow: 0px 10px 10px 0px
        rgba(50, 150, 255, 0.3);
        border-radius: 10px;
        text-align: center;
        line-height: 30px;

        i {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
    .list {
      width: 100%;
      .btn {
        width: 60px;
        height: 26px;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin: 0 auto;
        &.blue {
          color: #1aa7f6;
          background-color: #d7effc;
          cursor: pointer;
        }
        &.shen {
          color: #1aa7f6;
          //background-color: #d7effc;
          cursor: pointer;
        }
        &.gray {
          color: #8a8a8a;
          //background-color: #f2f2f2;
        }
        &.yellow {
          color: #fad471;
          //background-color: #fffbdd;
        }
        &.orange {
          color: #f58739;
          //background-color: #ffeedd;
        }
        &.green {
          color: #46b74f;
          //background-color: #ffdddd;
        }
        &.red {
          color: #f8001a;
          //background-color: #ffdddd;
        }
      }
    }
    .search-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 20px 0;
      .shensu {
        width: 113px;
        height: 37px;
        background-image: linear-gradient(0deg,
          #f59a23 0%,
          #feb555 100%);
        border-radius: 4px;
        text-align: center;
        line-height: 37px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #ffffff;
        }
      }
      .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .search-btn {
          width: 112px;
          height: 36px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
          cursor: pointer;
          i {
            font-size: 20px;
            margin-right: 5px;
            color: #ffffff;
          }
          &.reset {
            background-image:none;
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #cccccc;
            line-height: 34px;
            color: #333333;
            i {
              color: #999999;
            }
          }
        }
      }

    }
  }

}
</style>


